import type { FC } from 'react'
import type { MenuItemType } from '../../frontend-types'
import type { CardArticleType } from '../atoms/CardArticle'
import { CardArticle } from '../atoms/CardArticle'
import { MenuLink } from '../atoms/MenuLink'

export type MegaMenuSideProps = {
	menuTitle?: string
	cardArticle?: CardArticleType
	sideMenu?: MenuItemType[]
}

export const MegaMenuSide: FC<MegaMenuSideProps> = ({ menuTitle, cardArticle, sideMenu }) => {
	const title = cardArticle ? 'News highlight' : menuTitle
	return (
		<div>
			{title && (
				<div className="mb-4xl hidden w-full border-b-(length:--stroke-xs) border-b-blue-tint-40 tablet-l:block">
					<span className="mb-xl block text-h4 text-blue-tint-10">{title}</span>
				</div>
			)}
			<div>
				<div className="hidden tablet-l:block">
					{cardArticle && <CardArticle cardArticle={cardArticle} theme="secondary" />}
				</div>
				<ul className="mt-2xl flex flex-col gap-y-md">
					{sideMenu?.map((item) => (
						<MenuLink key={item.title} menuItem={item} />
					))}
				</ul>
			</div>
		</div>
	)
}
